var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},_vm._l((_vm.alphabet),function(letter,index){return _c('div',{key:index,staticClass:"letter",class:{
      letter_disabled: _vm.checkIsDisabled(letter),
    }},[_c('h3',{staticClass:"letter__title",class:{
        letter__title_selected: _vm.selectedLetter === letter,
        letter__title_disabled: _vm.checkIsDisabled(letter),
      },on:{"click":function($event){return _vm.onClickLetter(letter)}}},[_vm._v("\n      "+_vm._s(letter)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }